import { render, staticRenderFns } from "./SocialScriptsPanel.vue?vue&type=template&id=02bdc991&scoped=true"
import script from "./SocialScriptsPanel.vue?vue&type=script&lang=js"
export * from "./SocialScriptsPanel.vue?vue&type=script&lang=js"
import style0 from "./SocialScriptsPanel.vue?vue&type=style&index=0&id=02bdc991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdc991",
  null
  
)

export default component.exports